import { createFileRoute, redirect } from '@tanstack/react-router'
import { DepositDetailScreen } from '@/features/accounting-bank/deposit-detail-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/deposits/$depositId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_bank.view')) {
      throw redirect({ to: '/accounting/deposits' })
    }
  },
  component: DepositDetailRoute,
})

function DepositDetailRoute() {
  const { depositId } = Route.useParams()
  return <DepositDetailScreen depositId={depositId} />
}
